import { t } from "../../i18n";
import { NumberField } from "../../ui/NumberField";
import { Toggle } from "../../ui/Toggle";
import type { TabProps } from "./WallEditor";
import { Schematic } from "./Schematic";

export function WaterTab({ wall, update }: TabProps): JSX.Element {
  const w0 = wall.water;
  return (
    <>
      <Schematic variant="water" title={t("Su şeması")} />
      <Toggle id="wt-back" label={t("Duvar arkası yeraltı suyu")} hint={t("Drenaj varsa kapalı bırakın (TBDY 16.12.3.1)")} checked={w0.backLevel !== null} onChange={(on) => update((w) => { w.water.backLevel = on ? 1.0 : null; })} dimKey="wt.hw" />
      {w0.backLevel !== null ? <NumberField id="wt-backlvl" label={t("Arka su seviyesi (taban üstünden)")} symbol="hw" unit="m" value={w0.backLevel} onChange={(v) => update((w) => { w.water.backLevel = v; })} min={0.01} dimKey="wt.hw" /> : null}
      <Toggle id="wt-front" label={t("Duvar önünde su")} checked={w0.frontLevel !== null} onChange={(on) => update((w) => { w.water.frontLevel = on ? 0.5 : null; })} dimKey="wt.hwf" />
      {w0.frontLevel !== null ? <NumberField id="wt-frontlvl" label={t("Ön su seviyesi (taban üstünden)")} unit="m" value={w0.frontLevel} onChange={(v) => update((w) => { w.water.frontLevel = v; })} min={0.01} dimKey="wt.hwf" /> : null}
      <NumberField id="wt-gw" label={t("Suyun birim hacim ağırlığı")} symbol="γw" unit="kN/m³" value={w0.gammaWater} onChange={(v) => update((w) => { w.water.gammaWater = v; })} min={9} max={11} digits={2} dimKey="wt.gw" />
    </>
  );
}
